module.exports = "<div class=\"page-full\">\n  <div class=\"backdrop\"></div>\n  <div class=\"loading-file\">\n    <h5>Enviando arquivos...</h5>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading-file/loading-file.component.html
// module id = ./src/app/components/loading-file/loading-file.component.html
// module chunks = main